
import { Profile } from '@/types/database.types';

export const getInitials = (firstName?: string | null, lastName?: string | null): string => {
  const first = firstName?.charAt(0) || '';
  const last = lastName?.charAt(0) || '';
  return (first + last).toUpperCase() || '?';
};

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const filterUsers = (users: Profile[] | undefined, searchQuery: string): Profile[] => {
  if (!users) return [];
  
  if (!searchQuery) return users;
  
  const query = searchQuery.toLowerCase();
  return users.filter(user => 
    (user.first_name && user.first_name.toLowerCase().includes(query)) ||
    (user.last_name && user.last_name.toLowerCase().includes(query)) ||
    (user.email && user.email.toLowerCase().includes(query))
  );
};
